import * as React from 'react';

import CoEdit16 from './CoEdit16';

export const coEdit16 = () => <CoEdit16 />;

export default {
    title: 'Icon/Line/CoEdit16',
    component: CoEdit16,
    parameters: {
        notes: "`import CoEdit16 from 'box-ui-elements/es/icon/line/CoEdit16';`",
    },
};
